import React from 'react';

import { msalConfig } from '@/authConfig';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';

import { AbilityProvider } from './ability';
import { AuthProvider } from './use-auth';
import { CacheProvider } from './use-cache';
import { CreditStatusProvider } from './use-credit-status';
import { NotificationProvider } from './use-notifications';
import { PageProvider } from './use-page';
import { SidebarProvider } from './use-sidebar';

const msalInstance = new PublicClientApplication(msalConfig);

const AppProviders: React.FC = ({ children }) => {
  return (
    <PageProvider>
      <CacheProvider>
        <MsalProvider instance={msalInstance}>
          <AuthProvider>
            <AbilityProvider>
              <NotificationProvider>
                <SidebarProvider>
                  <CreditStatusProvider>{children}</CreditStatusProvider>
                </SidebarProvider>
              </NotificationProvider>
            </AbilityProvider>
          </AuthProvider>
        </MsalProvider>
      </CacheProvider>
    </PageProvider>
  );
};

export default AppProviders;
